<template>
  <div>
    <va-modal
      id="registerAttendanceModal"
      ref="registerAttendanceModal"
      class="evollu-form"
      size="medium"
      :value="showModal"
      :noOutsideDismiss="true"
      :okText="$t('modals.buttons.save')"
      :cancelText="$t('modals.buttons.cancel')"
      :dangerText="$t('modals.buttons.delete')"
      :showDelete="false"
      :okDisabled="isSubmitting || !canSubmitForm"
      @ok="submit"
      @cancel="cancel"
    >
      <div slot="header" class="modal-title">
        {{ handleTitle() }}
      </div>

      <div class="row no-gutters">
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <div>
                <label class="form-label">{{ $t("agenda.appointments.appointment_type") }}:</label>
                <multiselect
                  v-model="form.type"
                  :options="attendanceTypesOptions"
                  track-by="id"
                  label="name"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :placeholder="$t('agenda.appointments.appointment_type')"
                  :allow-empty="false"
                  :multiple="false"
                  :searchable="true">
                  <template slot="clear">
                <span class="multiselect__clear" v-if="form.type"
                      @mousedown.prevent.stop="() => form.type = null"></span>
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <div class="float-container">

                      <div class="float-child-left" :style="{ backgroundColor: props.option.color }">
                        <div></div>
                      </div>

                      <div class="float-child-right">
                        <div>{{props.option.name}}</div>
                      </div>

                    </div>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="float-container">

                      <div class="float-child-left" :style="{ backgroundColor: props.option.color }">
                        <div></div>
                      </div>

                      <div class="float-child-right">
                        <div>{{props.option.name}}</div>
                      </div>

                    </div>
                  </template>
                </multiselect>
              </div>
            </div>

            <div v-if="form.type && form.type.id === 1" class="col-3">
                <label class="form-label">{{ $t("agenda.availability.start") }}:</label>
                <vue-timepicker
                  :hour-range="[[8, 19]]"
                  :disabled="!form.type"
                  format="HH:mm"
                  v-model="form.start"
                >
                  <template
                    v-slot:dropdownButton
                  >+</template>
                </vue-timepicker>
              </div>
            <div v-if="form.type && form.type.id === 1" class="col-3">
                <label class="form-label">{{ $t("agenda.availability.end") }}:</label>
                <vue-timepicker
                  :hour-range="[[8, 19]]"
                  :disabled="!form.start"
                  format="HH:mm"
                  v-model="form.end"
                >
                  <template
                    v-slot:dropdownButton
                  >+</template>
                </vue-timepicker>
              </div>

          </div>
        </div>
      </div>

    </va-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Errors from "@/utils/StandardErrors";
import moment from "moment-timezone";
import DatePicker from "@/components/common/DatePicker.vue";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import { AttendandeAndVacationsService } from "@/api/AuthService";


export default {
  components: {Multiselect, DatePicker, VueTimepicker},
  props: {
    isForToday: {
      type: Boolean,
      required: false
    },
    event: {
      type: Object,
      required: false
    },
    date: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      showModal: false,
      isSubmitting: false,
      form: {
        type: null,
        start: null,
        end: null,
      },
      attendanceTypesOptions: [
        {id: 1, name: this.$t('attendance.types.presence'), color: '#96bb68'},
        {id: 2, name: this.$t('attendance.types.vacation'), color: '#e8cf48'},
        {id: 3, name: this.$t('attendance.types.sick'), color: '#d09351'},
        {id: 4, name: this.$t('attendance.types.medical_leave'), color: '#d09351'},
        {id: 5, name: this.$t('attendance.types.other'), color: '#d09351'}
      ],
      formErrors: new Errors(),
    }
  },
  mounted() {
    this.showModal = true
    if(this.event) {
      this.form.type = this.attendanceTypesOptions.find(elem => elem.id === this.event.type.id)
      setTimeout(() => {
        this.form.start = this.event.start.format('HH:mm')
      }, 200);
      setTimeout(() => {
        this.form.end = this.event.end.format('HH:mm')
      }, 200);
    }
  },
  methods: {
    handleTitle: function() {
      if(this.isForToday) {
        return this.$t('attendance.register_today')
      }
      //There is an event, it's update
      if(this.event) {
        if(this.event.start.isSame(moment(), 'day')) {
          return this.$t('attendance.update_event_for_today')
        } else {
          return this.$t('attendance.update_event_for_day', {date: this.event.start.format('YYYY-MM-DD')})
        }
      } else {
        //there is no event but we have a date, it's a creation for an earlier day
        if(this.date) {
          return this.$t('attendance.register_for_day', {date: this.date})
        }
      }
    },
    submit: function () {
      //Prepare for submission
      this.isSubmitting = true
      if(this.event) {
        //UPDATE
        const momentStartTime = moment.tz(this.form.start, 'HH:mm', 'Europe/Lisbon')
        const momentEndTime = moment.tz(this.form.end, 'HH:mm', 'Europe/Lisbon')
        let params = {
          type_id: this.form.type.id,
          start: moment.tz(this.event.start, 'Europe/Lisbon').set({hours: momentStartTime.hours(), minutes: momentStartTime.minutes()}).utc().format('YYYY-MM-DD HH:mm'),
          end: moment.tz(this.event.end, 'Europe/Lisbon').set({hours: momentEndTime.hours(), minutes: momentEndTime.minutes()}).utc().format('YYYY-MM-DD HH:mm'),
        }
        AttendandeAndVacationsService.updateAttendance(this.event.id, params)
          .then(res => {
            this.showToast(this.$t('attendance.update_success'), this.$store.state.successToastOptions)
            this.$emit('attendanceCreated')
          })
          .catch(err => {
            console.log(err)
            this.showToast(this.$t('attendance.update_error'), this.$store.state.errorToastOptions)
          })
          .finally(() => {
            this.isSubmitting = false
          })
      } else {
        let params = {
          type_id: this.form.type.id,
        }
        if(this.date) {
          const momentDate = moment.tz(this.date, 'Europe/Lisbon')
          params.start = momentDate.clone().set({hours: moment(this.form.start, 'HH:mm').hours(), minutes: moment(this.form.start, 'HH:mm').minutes()}).utc().format('YYYY-MM-DD HH:mm')
          params.end = momentDate.clone().set({hours: moment(this.form.end, 'HH:mm').hours(), minutes: moment(this.form.end, 'HH:mm').minutes()}).utc().format('YYYY-MM-DD HH:mm')
        } else {
          params.start = this.form.start ? moment.tz(this.form.start, 'HH:mm', 'Europe/Lisbon').utc().format('YYYY-MM-DD HH:mm') : null
          params.end = this.form.end ? moment.tz(this.form.end, 'HH:mm', 'Europe/Lisbon').utc().format('YYYY-MM-DD HH:mm') : null
        }
        AttendandeAndVacationsService.storeAttendance(params)
          .then(res => {
            this.showToast(this.$t('attendance.create_success'), this.$store.state.successToastOptions)
            this.$emit('attendanceCreated')
          })
          .catch(err => {
            console.log(err)
            this.showToast(this.$t('attendance.create_error'), this.$store.state.errorToastOptions)
          })
          .finally(() => {
            this.isSubmitting = false
          })
      }

    },
    cancel: function() {
      setTimeout(() => {
        this.$emit("cancel");
      }, 200);
    }
  },
  computed: {
    canSubmitForm: function () {
      if(!this.form.type) {
        return false
      }

      if(this.form.type.id === 1 && moment(this.form.start, 'HH:mm', true).isValid() && moment(this.form.end, 'HH:mm', true).isValid()) {
        return true
      }

      return true

    },
  },
  watch: {
    'form.type': function(val) {
      if(val) {
        if(val.id === 1) {
          this.form.start = moment().tz('Europe/Lisbon').set({hour: 9, minute: 0}).format("HH:mm")
          this.form.end = moment().tz('Europe/Lisbon').set({hour: 18, minute: 0}).format("HH:mm")
        } else {
          this.form.start = this.form.end = null
        }
      } else {
        this.form.start = null
        this.form.end = null
      }
    },
    'form.start': function(val) {
      if(val) {
        this.form.end = moment(this.form.start, 'HH:mm').add(9, 'hours').format("HH:mm")
      } else {
        this.form.end = null
      }
    }
  }
};
</script>

<style lang="scss">

.color-stripe {
  display: inline-block;
  width: 10px; /* Adjust the width as needed */
  height: 100%;
  margin-right: 5px; /* Adjust the spacing as needed */
}

.float-container {
}

.float-child-left {
  height: 20px;
  width: 2%;
  float: left;
}

.float-child-right{
  width: 97%;
  float: right;
}
</style>
